import { render } from "./DataTable.vue?vue&type=template&id=65b830d8&scoped=true"
import script from "./DataTable.vue?vue&type=script&lang=js"
export * from "./DataTable.vue?vue&type=script&lang=js"

import "./DataTable.vue?vue&type=style&index=0&id=65b830d8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b830d8"],['__file',"src/common/components/BaseTable/DataTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "65b830d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('65b830d8', __exports__)) {
    api.reload('65b830d8', __exports__)
  }
  
  module.hot.accept("./DataTable.vue?vue&type=template&id=65b830d8&scoped=true", () => {
    api.rerender('65b830d8', render)
  })

}


export default __exports__